import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UserApiService } from '../user-api.service';

@Component({
  selector: 'app-sidenav-content',
  templateUrl: './sidenav-content.component.html',
  styleUrls: ['./sidenav-content.component.scss']
})
export class SidenavContentComponent implements OnInit {
  _islog : boolean = false;

  @Output() close = new EventEmitter<boolean>();

  CloseAction() {
    this.close.emit(true);
  }

  Closed(v) {
    this.close.emit(true);
  }

  constructor(private userApiService : UserApiService) { }

  ngOnInit() {
    this.userApiService.getCurrentUserData().subscribe(
      response => {
        if (response != undefined) {
          this._islog = true;
        }
      },
      error => {
        this._islog = false;        
      }
    );
  }

}
